import React, { Component } from 'react';
import { Container, Row, Col, Card, Badge, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { GoRepo } from 'react-icons/go';
import ExternalLink from 'components/controls/ExternalLink/index';
import BlobHeaderToggle from 'components/blob/BlobHeaderToggle/index';
import ReactGA from 'react-ga';
import Utils from 'context/utils';
import './index.css';

export default class BlobHeader extends Component {
  shouldShowDescriptionLine() {
    return (
      ( this.props.blob.description && this.props.blob.description.length > 0 ) ||
      ( this.props.blob.url && this.props.blob.url.length > 0 ) ||
      ( this.props.blob.tags && this.props.blob.tags.length > 0 )
    );
  }

  render() {
    const orgId = this.props.match.params.orgId;
    const scope = this.props.scope || {};

    return (
      <>
        <Container className="blob-header-row repo-name-row">
          <Row>
            <Col sm={6}>
              <h5>
                <GoRepo/>
                &nbsp;&nbsp;<Link to={`/${orgId}`}>{Utils.displayName(this.props.org, orgId)}</Link> /&nbsp;
                <Link to={`/${orgId}/${this.props.blob.alias}`}>
                  {Utils.displayName(this.props.blob)}
                </Link>
              </h5>
            </Col>
            <Col sm={6} className="text-right">
              <BlobHeaderToggle scope={scope}/>
            </Col>
          </Row>
        </Container>
          <Container className="blob-header-row repo-description-row">
            {this.shouldShowDescriptionLine() &&
              <>
                {this.props.blob.description && this.props.blob.description.length > 0 &&
                  <>
                    {this.props.blob.description}&nbsp;
                  </>
                }
                {this.props.blob.url && this.props.blob.url.length > 0 &&
                  <>
                    <ExternalLink href={this.props.blob.url} text={this.props.blob.url}/>&nbsp;
                  </>
                }
                {this.props.blob.tags && this.props.blob.tags.length > 0 &&
                  <>
                    {this.props.blob.tags.map((tag, index) => {
                      return (
                        <>
                          <Badge variant="secondary" className="tag-badge">{tag}</Badge>
                          &nbsp;
                        </>
                      );
                    })}
                  </>
                }
              </>
            }
          </Container>
      </>
    );
  }
}
